import { useMutation } from "@tanstack/react-query";
import { useCallback } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { PostSavedLists } from "../../api/api"; // <-- make sure this matches your actual API export

// the shape of the API’s response
type SaveListResult = {
  status: string;
  message?: string;
  errorCode?: string;
};

// what the hook’s caller will pass in
type SaveListPayload = {
  filterType: string;
  filterListName: string;
  filterList: string[];
};

export const usePostSaveList = () => {
  const { getAccessTokenSilently } = useAuth0();

  const mutation = useMutation<
    SaveListResult, // data
    unknown, // error
    SaveListPayload & { token: string } // variables
  >({
    // sends POST /save-filter-list (or whatever your endpoint is)
    mutationFn: async ({
      filterType,
      filterListName,
      filterList,
      token,
    }) => {
      return PostSavedLists(
        { filterType, filterListName, filterList },
        token
      );
    },

    onSuccess: (data) => {
      // e.g. show a toast or invalidateQueries(...)
    },
    onError: (error) => {
      // handle/report errors
    },
  });

  const mutate = useCallback(
    async (
      payload: SaveListPayload,
      options?: {
        onSuccess?: (data: SaveListResult) => void;
        onError?: (error: unknown) => void;
        onSettled?: () => void;
      }
    ) => {
      const token = await getAccessTokenSilently();
      return mutation.mutateAsync(
        { ...payload, token },
        {
          onSuccess: options?.onSuccess,
          onError: options?.onError,
          onSettled: options?.onSettled,
        }
      );
    },
    [getAccessTokenSilently, mutation]
  );

  return { ...mutation, mutate };
};
